var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_88_1581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 36C16.5 24.7643 16.5 19.1465 19.1965 15.1109C20.3638 13.3638 21.8638 11.8638 23.6109 10.6965C27.6465 8 33.2643 8 44.5 8C55.7357 8 61.3535 8 65.3891 10.6965C67.1362 11.8638 68.6362 13.3638 69.8035 15.1109C72.5 19.1465 72.5 24.7643 72.5 36C72.5 47.2357 72.5 52.8535 69.8035 56.8891C68.6362 58.6362 67.1362 60.1362 65.3891 61.3035C61.3535 64 55.7357 64 44.5 64C33.2643 64 27.6465 64 23.6109 61.3035C21.8638 60.1362 20.3638 58.6362 19.1965 56.8891C16.5 52.8535 16.5 47.2357 16.5 36Z",
    fill: "url(#paint0_linear_88_1581)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6875 28.4375L50.125 26.5625L48.25 20H35.125C33.5717 20 32.3125 21.2592 32.3125 22.8125V49.1875C32.3125 50.7408 33.5717 52 35.125 52H53.875C55.4283 52 56.6875 50.7408 56.6875 49.1875V28.4375Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 36.9375C37.5178 36.9375 37.9375 36.5178 37.9375 36C37.9375 35.4822 37.5178 35.0625 37 35.0625C36.4822 35.0625 36.0625 35.4822 36.0625 36C36.0625 36.5178 36.4822 36.9375 37 36.9375Z",
    fill: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 40.6875C37.5178 40.6875 37.9375 40.2678 37.9375 39.75C37.9375 39.2322 37.5178 38.8125 37 38.8125C36.4822 38.8125 36.0625 39.2322 36.0625 39.75C36.0625 40.2678 36.4822 40.6875 37 40.6875Z",
    fill: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 44.4375C37.5178 44.4375 37.9375 44.0178 37.9375 43.5C37.9375 42.9822 37.5178 42.5625 37 42.5625C36.4822 42.5625 36.0625 42.9822 36.0625 43.5C36.0625 44.0178 36.4822 44.4375 37 44.4375Z",
    fill: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6875 28.4375V49.1875C56.6875 50.7408 55.4283 52 53.875 52H44.5V20H48.25L50.125 26.5625L56.6875 28.4375Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.125 36.9375H40.75C40.2318 36.9375 39.8125 36.5182 39.8125 36C39.8125 35.4818 40.2318 35.0625 40.75 35.0625H50.125C50.6432 35.0625 51.0625 35.4818 51.0625 36C51.0625 36.5182 50.6432 36.9375 50.125 36.9375Z",
    fill: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.125 40.6875H40.75C40.2318 40.6875 39.8125 40.2682 39.8125 39.75C39.8125 39.2318 40.2318 38.8125 40.75 38.8125H50.125C50.6432 38.8125 51.0625 39.2318 51.0625 39.75C51.0625 40.2682 50.6432 40.6875 50.125 40.6875Z",
    fill: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.125 44.4375H40.75C40.2318 44.4375 39.8125 44.0182 39.8125 43.5C39.8125 42.9818 40.2318 42.5625 40.75 42.5625H50.125C50.6432 42.5625 51.0625 42.9818 51.0625 43.5C51.0625 44.0182 50.6432 44.4375 50.125 44.4375Z",
    fill: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 44.4375H50.125C50.6432 44.4375 51.0625 44.0182 51.0625 43.5C51.0625 42.9818 50.6432 42.5625 50.125 42.5625H44.5V44.4375Z",
    fill: "#E3E7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 40.6875H50.125C50.6432 40.6875 51.0625 40.2682 51.0625 39.75C51.0625 39.2318 50.6432 38.8125 50.125 38.8125H44.5V40.6875Z",
    fill: "#E3E7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 36.9375H50.125C50.6432 36.9375 51.0625 36.5182 51.0625 36C51.0625 35.4818 50.6432 35.0625 50.125 35.0625H44.5V36.9375Z",
    fill: "#E3E7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6875 28.4375H50.125C49.0938 28.4375 48.25 27.5938 48.25 26.5625V20C48.4938 20 48.7375 20.0938 48.9062 20.2813L56.4062 27.7813C56.5938 27.95 56.6875 28.1938 56.6875 28.4375Z",
    fill: "#D3A837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_88_1581",
    x: 0.5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.658824 0 0 0 0 0.215686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_1581"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88_1581",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_1581",
    x1: 44.5,
    y1: 8,
    x2: 44.5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE88"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.8e7992083cb4c384331d7ea96df5927f.svg";
export { ForwardRef as ReactComponent };